var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1Fridge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 3h-37A5.51 5.51 0 0014 8.5v56a5.51 5.51 0 005.5 5.5h3.26v1a2 2 0 004 0v-1h22.48v1a2 2 0 004 0v-1h3.26a5.51 5.51 0 005.5-5.5v-56A5.51 5.51 0 0056.5 3zM58 64.5a1.5 1.5 0 01-1.5 1.5h-37a1.5 1.5 0 01-1.5-1.5V27h40v37.5zM58 23H18V8.5A1.5 1.5 0 0119.5 7h37A1.5 1.5 0 0158 8.5V23zM26 62h-4V31h4v31zm-4-51h4v8h-4v-8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Fridge.d983bdfb.svg";
export { SvgD1Fridge as ReactComponent };